import React from "react";
import { Checkbox, Row, Col } from "antd";
import Axios from 'axios';

function onChange(checkedValues) {
  console.log('checked = ', checkedValues);
}


class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      domain:"http://10.0.7.152:8082",
      domain2:"https://www.cloudstopower.com",
    };
  }

 
  requestData=()=>{
    var api=this.state.domain+"/user/getCards";
    Axios.post(api)
    .then((res)=>{
       console.log(res)
       this.setState({
           list:res.data.data
   })
   console.log(this.state.list[0].title)
    })
   .catch((error)=>{
       console.log(error)
   })
 }
 
  
   componentDidMount(){
      this.requestData();
   }


  render() {
    return (
      <div>
        读书卡合并
        <Checkbox.Group style={{ width: "100%" }} onChange={onChange}>
          <Row >
            <div>
            <Col span={8}>
              <Checkbox value="A">
              <div>
                卡号:<input />
                金额:<input/>
              </div>
              </Checkbox>
            </Col>
            </div>
            <br/>
            <Col span={8}>
              <Checkbox value="B">B</Checkbox>
            </Col>
            <br/>
            <Col span={8}>
              <Checkbox value="C">C</Checkbox>
            </Col>
            <br/>
            <Col span={8}>
              <Checkbox value="D">D</Checkbox>
            </Col>
            <br/>
            <Col span={8}>
              <Checkbox value="E">E</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
        ,
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/User/Main.js